import React, { useEffect, useRef, useState } from "react";

import { Box, Checkbox, Divider, FormControlLabel } from "@mui/material";
import { DocumentData } from "util/interfaces/DocumentData";
import { FileData } from "util/interfaces/FileData";

import { SelectMetadataForm } from "../SelectMetadataForm";

import StepTwoFileItem from "./StepTwoFileItem";

interface StepTwoProps {
  files: FileData[];
  currentFile?: DocumentData;
  callbackSetMessage: (_message: string) => void;
  callbackSetFiles: (_files: FileData[]) => void;
}
const StepTwo: React.FC<StepTwoProps> = ({
  files,
  callbackSetMessage,
  callbackSetFiles,
  currentFile,
}) => {
  const [internalFiles, setInternalFiles] = useState<FileData[]>(files);
  const prevIsCompletedRef = useRef<number>(0);

  useEffect(() => {
    callbackSetFiles(internalFiles);

    const isCompletedLength = internalFiles.filter((f) => f.isCompleted).length;
    if (isCompletedLength > prevIsCompletedRef?.current) {
      prevIsCompletedRef.current = isCompletedLength;

      callbackSetMessage(
        `(${isCompletedLength}/${internalFiles.length}) Document details are saved`
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [internalFiles]);

  const getFieldValue = (fieldName: "fileCategory" | "metadata") => {
    const selectedInternalFiles = internalFiles.filter((file) => file.isChecked);
    return selectedInternalFiles.length > 0 &&
      selectedInternalFiles.every((file) => file[fieldName] === selectedInternalFiles[0][fieldName])
      ? selectedInternalFiles[0][fieldName]
      : "";
  };

  const fileCategoryValue = getFieldValue("fileCategory");
  const metadataValue = getFieldValue("metadata");

  return (
    <div className="grid-files-details" data-testid="stepTwo">
      <div className="selected-files flex flow-column">
        <span style={{ fontSize: "16px" }} className="title">
          Selected files
        </span>
        <span style={{ fontSize: "14px", marginTop: "10px" }}>
          Select an attachement to input details.
        </span>
        <div>
          <FormControlLabel
            label="Select All"
            control={
              <Checkbox
                checked={internalFiles.every((file) => file.isChecked)}
                indeterminate={
                  internalFiles.some((file) => file.isChecked) &&
                  !internalFiles.every((file) => file.isChecked)
                }
                onChange={(_, checked) => {
                  setInternalFiles(internalFiles.map((file) => ({ ...file, isChecked: checked })));
                }}
              />
            }
            sx={{ paddingLeft: "10px" }}
          />
          <Divider component="div" />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              paddingLeft: "10px",
              overflowX: "auto",
              height: "calc(65vh - 266px)",
            }}
          >
            {internalFiles?.map((file, index) => (
              <StepTwoFileItem
                key={`fileItem-${index}-${file.file.name}`}
                file={file}
                index={index}
                setInternalFiles={setInternalFiles}
                currentFile={currentFile}
              />
            ))}
          </Box>
        </div>
      </div>
      <div className="separator"></div>
      <SelectMetadataForm
        internalFiles={internalFiles}
        fileCategoryValue={fileCategoryValue}
        setInternalFiles={setInternalFiles}
        metadataValue={metadataValue}
      />
    </div>
  );
};

export default StepTwo;
